import accordionFactory from "./accordionFactory";

export default function() {
    const header = document.querySelector('.js-wholesale-header');

    if (header) {
        accordionFactory([header]).init();
    }
}